
import { GuiButton } from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";


export interface btnConfig{
    textValue:string;
    size:PIXI.Point;
    cb:Function;
    color?:number;
}

export class DebugButton extends GuiButton {

    private btnText:PIXI.Text;
    private bgGraphic:PIXI.Graphics;
    private _conf:btnConfig;

    constructor(conf:btnConfig){
        super(conf.textValue, conf.cb);

        this._conf = conf;
        this.init();
        this.buttonInteractionState();
    }

    private init():void{
        this.buttonBg();
        this.buttonText();
    }

    private get boxHeight():number { return this._conf.size.y; }

    private get boxWidht():number { return this._conf.size.x; }

    protected buttonInteractionState():void{
        this.onPointerStateUpdate = state => {
            switch(state){
                case 2:
                    this.objAlpha = 0.9;
                    break;
                case 1:
                    this.objAlpha = 0.8;
                    break;
                default:
                    this.objAlpha = 1;
                    break;
            }
        };
    }

    public buttonText():void{
        this.btnText = this.addChild(new PIXI.Text(this.name));
        this.btnText.anchor.set(0.5,0.5);
        this.btnText.scale.set(1,1)
    }

    public changeText(changeName?:string):void{
        this.name = changeName ? changeName : this.name;
        this.btnText.text = this.name;
        this.paintBgButton();
    }

    private set objAlpha(value:number){
        this.btnText.alpha = value;
        this.bgGraphic.alpha = value;
    }

    public updateConf(conf:btnConfig):void{
        this._conf = conf;
        this.paintBgButton();
        this.position.set(conf.size.x/2,conf.size.y/2)
    }

    private paintBgButton():void{
        this.bgGraphic.clear();
        this.bgGraphic.lineStyle(3, 0xffffff, 1);
        this.bgGraphic.beginFill(this._conf.color != undefined ?  this._conf.color : 0xBB4588, 1);

        this.bgGraphic.drawRoundedRect(
            -this.boxWidht/2,
            -this.boxHeight/2,
            this.boxWidht,
            this.boxHeight,14);
        this.bgGraphic.endFill();
    }

    public buttonBg():void{
        this.bgGraphic = this.addChild(new PIXI.Graphics());

        this.paintBgButton();
        this.enable(true)
    }
}